import React, { useCallback, useMemo } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CustomDashboard } from '../../components/CustomDashboard/CustomDashboard';
import { createShareDashboardApi } from '../../components/CustomDashboard/shareApi';

// Public viewer behind a share link (/custom-dashboards/:id/share?h=...).
// Mirrors the narrative/report share pages: no app session, data fetched with
// the share token, and an expired token sends the viewer back to the share
// login page with the original hash so they can re-enter the password.
export const DashboardSharePage: React.FC = () => {
  const { dashboardId } = useParams<{ dashboardId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const hash = searchParams.get('h');
  const withPassword = searchParams.get('with_password');

  const redirectToLogin = useCallback(() => {
    if (!dashboardId) return;
    const params = new URLSearchParams();
    if (hash) params.set('h', hash);
    if (withPassword) params.set('with_password', withPassword);
    navigate(
      `/custom-dashboards/${dashboardId}/share/login?${params.toString()}`,
      { replace: true },
    );
  }, [navigate, dashboardId, hash, withPassword]);

  const shareApi = useMemo(
    () =>
      dashboardId
        ? createShareDashboardApi(dashboardId, redirectToLogin)
        : undefined,
    [dashboardId, redirectToLogin],
  );

  if (!dashboardId || !shareApi) {
    return null;
  }

  return (
    <CustomDashboard
      dashboardId={dashboardId}
      isAdmin={false}
      isShare
      api={shareApi}
    />
  );
};
